import { makeRequest } from '../client';

export const getPublicPlatformBrand = async () => makeRequest('brand', 'getPublic');
